module.exports = __webpack_public_path__ + "img/TZ.327c30be.png";